import React, { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { InfoPage, InfoBody, InfoSectionTitle, FaqList } from "../infoShared";

const VOTERS = [
  { q: "Czy muszę mieć konto, żeby zagłosować?", a: "Nie. Głosujesz z linku otrzymanego od organizatora albo zapisując się do głosowania otwartego — logowanie nie jest potrzebne." },
  { q: "Jak oddać głos?", a: "Otwórz link do głosowania, wybierz odpowiedzi i wyślij. Następnie sprawdź skrzynkę e-mail i potwierdź swój głos, klikając w link z wiadomości." },
  { q: "Czy mój głos jest tajny?", a: "To zależy od ustawień głosowania. Organizator może wybrać głosowanie tajne (bez powiązania głosu z osobą) albo jawne imienne." },
  { q: "Nie dostałem/am linku do głosowania — co robić?", a: "Sprawdź folder spam. Jeśli linku nie ma, skontaktuj się z organizatorem głosowania — to on zarządza listą uprawnionych." }
];

const ORGANIZERS = [
  { q: "Ile kosztuje stworzenie głosowania?", a: "Tworzenie i prowadzenie głosowań jest darmowe — bez opłat i ukrytych kosztów." },
  { q: "Jak zaprosić uczestników?", a: "Masz trzy drogi: wgrać listę uprawnionych, otworzyć zapisy (vox populi) lub udostępnić głosowanie otwarte ze zweryfikowaną tożsamością. Uprawnionych możesz też dopisać ręcznie przed startem." },
  { q: "Czy mogę ustawić kworum i próg przyjęcia?", a: "Tak. Dla każdego głosowania ustawisz kworum (frekwencję), a dla pytań próg przyjęcia — od zwykłej większości po próg własny." },
  { q: "Co dostaję po zakończeniu?", a: "Protokół głosowania zakotwiczony na blockchainie oraz podpisany PDF z wynikiem — gotowy do dokumentacji." }
];

const SECURITY = [
  { q: "Na czym polega zakotwiczenie na blockchainie?", a: "Po zakończeniu głosowania jego protokół jest hashowany i zapisywany w łańcuchu. Dzięki temu jakiejkolwiek późniejszej zmiany wyniku nie da się ukryć." },
  { q: "Jak mogę sprawdzić, że wynik nie został zmieniony?", a: "Wynik możesz zweryfikować niezależnie, porównując opublikowany protokół z zapisem zakotwiczonym w łańcuchu." },
  { q: "Czym jest weryfikacja tożsamości?", a: "Dla głosowań otwartych (referendów) organizator może wymagać potwierdzenia tożsamości — uczestnictwo pozostaje anonimowe, a do urny trafiają tylko uprawnione osoby." }
];

export const FAQView: React.FC = () => {
  useEffect(() => {
    document.title = "Najczęściej zadawane pytania";
  }, []);

  return (
    <InfoPage
      eyebrow="Pomoc"
      title="Najczęściej zadawane pytania"
      subtitle="Wszystko, co chcesz wiedzieć o głosowaniu i organizowaniu głosowań na naszej platformie."
    >
      <InfoBody narrow>
        <InfoSectionTitle>Dla głosujących</InfoSectionTitle>
        <FaqList items={VOTERS} />

        <Box mt={{ base: "40px", md: "52px" }}>
          <InfoSectionTitle>Dla organizatorów</InfoSectionTitle>
          <FaqList items={ORGANIZERS} />
        </Box>

        <Box mt={{ base: "40px", md: "52px" }}>
          <InfoSectionTitle>Bezpieczeństwo i zaufanie</InfoSectionTitle>
          <FaqList items={SECURITY} />
        </Box>
      </InfoBody>
    </InfoPage>
  );
};
